export class Product {

  public productId: number
  public crmId: string
  public name: string
  public prices: Record<string, string>

  public constructor(values: Record<string, unknown> = {}) {
    this.productId = (values.productId as number) || 0
    this.crmId = (values.crmId as string) || ''
    this.name = (values.name as string) || ''
    this.prices = (values.prices as Record<string, string>) || {}
  }

}

